export enum VsdOperationType {
    ConverterOperationVSD,
    LineOperation,
    LineAndConverterOperationVSD
}
